import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "company", "file", "integration", "spinner"]
  static values = {
    integrations: Object,
    selectedIntegration: String,
    thinkingText: String,
  }

  connect() {
    this.renderIntegrationOptions()
    this.updateButtonState()
  }

  fileChanged() {
    this.updateButtonState()
  }

  companyChanged() {
    this.renderIntegrationOptions()
    this.updateButtonState()
  }

  submit() {
    if (!this.hasButtonTarget) return

    this.updateButtonState()
    if (this.buttonTarget.disabled) return

    const button = this.buttonTarget
    button.dataset.originalText = button.textContent.trim()
    button.textContent = this.thinkingTextValue || "Thinking..."
    button.classList.add("is-loading")
    button.setAttribute("disabled", "disabled")
    this.showSpinner()
  }

  updateButtonState() {
    if (!this.hasButtonTarget) return
    if (!this.hasFileTarget) {
      this.buttonTarget.removeAttribute("disabled")
      return
    }

    const hasFile = this.fileTarget.files && this.fileTarget.files.length > 0
    const hasCompany = !this.hasCompanyTarget || this.companyTarget.value.trim().length > 0
    const hasIntegration = !this.hasIntegrationTarget || this.integrationTarget.value.trim().length > 0
    if (hasFile && hasCompany && hasIntegration) {
      this.buttonTarget.removeAttribute("disabled")
      this.buttonTarget.classList.remove("is-disabled")
      this.hideSpinner()
    } else {
      this.buttonTarget.setAttribute("disabled", "disabled")
      this.buttonTarget.classList.add("is-disabled")
      this.hideSpinner()
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("is-active")
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("is-active")
    }
  }

  renderIntegrationOptions() {
    if (!this.hasIntegrationTarget) return

    const companyId = this.hasCompanyTarget ? this.companyTarget.value.trim() : ""
    const options = this.integrationsValue?.[companyId] || []
    const previousValue = this.integrationTarget.value.trim()
    const selectedValue = previousValue || this.selectedIntegrationValue || (options.length === 1 ? options[0].value : "")

    this.integrationTarget.innerHTML = ""

    const placeholder = document.createElement("option")
    placeholder.value = ""
    placeholder.textContent = "Select a Bill.com instance"
    this.integrationTarget.appendChild(placeholder)

    for (const option of options) {
      const element = document.createElement("option")
      element.value = option.value
      element.textContent = option.label
      if (option.value === selectedValue) element.selected = true
      this.integrationTarget.appendChild(element)
    }

    if (options.length === 1 && !this.integrationTarget.value) {
      this.integrationTarget.value = options[0].value
    }
  }
}
